import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import {
  LINK_TYPE,
  TYPE_ACTION_WORKFLOW,
  TYPE_ADJUST_INVOICE,
  TYPE_INVOICE_ANOTHER,
  TYPE_REPORT_WORD,
} from "constants/IssueInvoiceConstant";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { TENANT_CODE } from "constants/TennantConstant";
import { getResourceIdXML } from "helpers/form_helper";
import {
  getFileNameExcel,
  numberWithCommas,
  toastWarningIsAllStore,
} from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  downloadXmlIssueInvoice,
  exportInvoice,
  getCloneEnvoice,
  getDataLink,
  getInvoiceMinDate,
  getInvoiceReportWord,
  listInvoiceSymbol,
  listIssueInvoice,
  releaseIssueInvoice,
  resetActionWorkflowIssueInvoice,
  resetAdjustIssueInvoice,
  resetCancelIssueInvoice,
  resetCloneEnvoice,
  resetCreateIssueInvoiceEnterprise,
  resetDeleteIssueInvoice,
  resetDownloadXmlIssueInvoice,
  resetDownloadZipInvoice,
  resetExportInvoice,
  resetGetInvoiceMinDate,
  resetGetInvoiceReportWord,
  resetListInvoiceSymbol,
  resetListIssueInvoice,
  resetReleaseIssueInvoice,
  resetReplaceIssueInvoice,
  resetSetBuStoreHeader,
  resetUploadFileInvoice,
  setListIssueInvoiceColumn,
} from "store/actions";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_ZIP_INVOICE_FAIL,
  DOWNLOAD_ZIP_INVOICE_SUCCESS,
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_SUCCESS,
  GET_INVOICE_REPORT_WORD_FAIL,
  GET_INVOICE_REPORT_WORD_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
  UPLOAD_FILE_INVOICE_FAIL,
  UPLOAD_FILE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailInvoice from "../DetailInvoice";
import { getInvoiceStatus } from "../helper/functionHelper";
import CompareInvoiceModal from "../modal/CompareInvoiceModal";
import PDFViewModal from "../modal/PDFViewModal";
import SignHSMModal from "../modal/SignHSMModal";
import TypeSignDigitalModal from "../modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "../modal/VerifyPinUSBModal";
import {
  checkDateWhenRelease,
  COMMON_CONDITION_VISIBLE,
  getPathNameFile,
  getRowInvoiceReplaceAdjustInfo,
  getTypeWorkflowMessage,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "../utils";

const ListInvoiceError = props => {
  const {
    filterList,
    title,
    titleManger,
    listStatusFilter,
    listLinkTypeFilter,
    isErrorTCT,
    children,
    isClickSwitch,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["issueInvoice"]);
  const { addToast } = useToasts();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    workflowInvoice,
    exportInvoiceData,
    linkTypeData,
    adjustIssueInvoice: adjustIssueInvoiceData,
    replaceIssueInvoice: replaceIssueInvoiceData,
    createInvoiceEnterpriseData,
    invoiceMaxDate,
    invoiceMaxMinDate,
    downloadZipInvoiceData,
  } = issueInvoice;

  const childRef = useRef();
  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const { errorList: errorInvoiceSymbolList, list: invoiceSymbolList } =
    invoiceSymbol;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [pageView, setPageView] = useState(null);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () =>
    setModalConfirmCancel(!modalConfirmCancel);
  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });
  // Lí do từ chối duyệt
  const [noteReject, setNoteReject] = useState(null);
  const [modalReject, setModalReject] = useState(false);
  const toggleRejectModal = () => setModalReject(!modalReject);
  // Update File modal
  const [idRootInvoice, setIdRootInvoice] = useState(false);
  const [modalUploadFile, setModalUploadFile] = useState(false);
  const toggleUploadFileModal = () => setModalUploadFile(!modalUploadFile);

  // modalCheckRelease
  const [rowRelease, setRowRelease] = useState(null);
  const [titleBodyCheckRelease, setTitleBodyCheckRelease] = useState("");
  const [modalCheckRelease, setModalCheckRelease] = useState(false);
  const toggleCheckReleaseModal = () =>
    setModalCheckRelease(!modalCheckRelease);

  // modalDenyRelease
  const [titleBodyDenyRelease, setTitleBodyDenyRelease] = useState("");
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    tenantCodeHeader,
    finalBuInfo,
    type: typeDashboard,
    buStoreHeader,
    finalListBuCode,
  } = Dashboard;
  const history = useHistory();

  const [isEnterprise, setIsEnterprise] = useState(false);
  const [isCreateAdjust, setIsCreateAdjust] = useState(false);
  const [idAdjust, setIdAdjust] = useState(false);

  const [invoiceSelect, setInvoiceSelect] = useState([]);
  const selectRowCheckbox = {
    mode: "checkbox",
  };
  const onRowsSelect = value => {
    setInvoiceSelect(value);
  };

  const queryData = () => {
    setInvoiceSelect([]);
    // Role kế toán chỉ xem hóa đơn chờ duyệt và đã duyệt
    if (
      isRoleAccountant &&
      finalBuInfo?.need_approve === 1 &&
      !issueInvoiceList.params.columnFilter["filter[approve_status]"]
    ) {
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        "filter[approve_status][in]": [APPROVE_STATUS_P, APPROVE_STATUS_A],
      };
    }
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      //   "filter[campaign_id]": "NULL",
    };
    if (issueInvoiceList.params.columnFilter["filter[auth_status]"]) {
      delete issueInvoiceList.params.columnFilter["filter[auth_status][in]"];
    }
    if (issueInvoiceList.params.columnFilter["filter[link_type]"]) {
      delete issueInvoiceList.params.columnFilter["filter[link_type][in]"];
    }
    if (issueInvoiceList.params.columnFilter["filter[status_done]"]) {
      switch (issueInvoiceList.params.columnFilter["filter[status_done]"]) {
        case "0":
          issueInvoiceList.params.columnFilter["filter[auth_status][nin]"] = [
            AUTH_STATUS_APPROVE,
            AUTH_STATUS_CANCEL,
          ];
          break;
        case "1":
          issueInvoiceList.params.columnFilter["filter[auth_status][in]"] = [
            AUTH_STATUS_APPROVE,
            AUTH_STATUS_CANCEL,
          ];
          break;
        default:
          break;
      }
      delete issueInvoiceList.params.columnFilter["filter[status_done]"];
    }
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        isErrorTCT ? TYPE_INVOICE_ANOTHER.ERROR_TCT : undefined
      )
    );
  };

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
        // "filter[invoice_type]": finalBuInfo?.invoice_type,
      };
      queryData();
      dispatch(resetSetBuStoreHeader());
      generateBtnFooter();
    }
  }, [typeDashboard]);

  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (successClone && tenantCodeHeader) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
      };
      queryData();
      addToast("Đã nhân bản tờ hóa đơn", {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCloneEnvoice());
    }
  }, [successClone, tenantCodeHeader]);
  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };

    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleInvoice) {
      initColumn();
    }
  }, [issueInvoiceList]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnSubmitEdit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const [isSendSubmitEdit, setIsSendSubmitEdit] = useState(false);

  const generateBtnFooter = () => {
    setBtnShowFooter({
      btnSubmitEdit: {
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        listConditionRow: [
          COMMON_CONDITION_VISIBLE.REPLACE,
          COMMON_CONDITION_VISIBLE.ADJUST,
        ],
        onClick: () => {
          setIsSendSubmitEdit(true);
        },
        toggleModal: null,
      },
    });
  };

  // Action Dispatch
  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
    if (isClickSwitch) {
      resetDataFunc();
    }
  }, []);

  const location = useLocation();

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }

    if (errorInvoiceSymbolList) {
      addToast(
        errorInvoiceSymbolList.message ||
          t("message.list", {
            target: t("invoice_symbol"),
            status: t("message.error"),
          }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorInvoiceSymbolList, errorList, t]);

  // Get list KHHD
  const getListInvoiceSymbol = ttchung_khmshdon => {
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[bu_code]": localStorage.getItem(BU_STORE_HEADER),
      "filter[khmhdon]": ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields =
      "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params));
  };

  useEffect(() => {
    switch (type) {
      case GET_INVOICE_REPORT_WORD_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetGetInvoiceReportWord());
        break;
      }
      case GET_INVOICE_REPORT_WORD_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetGetInvoiceReportWord());
        break;
      //
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }

        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast("Lập hóa đơn thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        dispatch(resetReplaceIssueInvoice());
        // Thay thế xong gửi duyệt lun
        if (isSendSubmitEdit) {
          dispatch(
            actionWorkflowIssueInvoice(
              replaceIssueInvoiceData?.data?.id,
              TYPE_ACTION_WORKFLOW.SUBMIT,
              null
            )
          );
          setIsSendSubmitEdit(false);
        } else {
          resetDataFunc();
        }
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        if (
          replaceIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập hóa đơn thay thế thất bại, tồn tại hóa đơn thay thế chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập hóa đơn thay thế thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }

        dispatch(resetReplaceIssueInvoice());
        break;
      case ADJUST_ISSUE_INVOICE_SUCCESS:
        addToast("Lập hóa đơn điều chỉnh thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        dispatch(resetAdjustIssueInvoice());
        // Điều chỉnh xong gửi duyệt lun
        if (isSendSubmitEdit) {
          dispatch(
            actionWorkflowIssueInvoice(
              adjustIssueInvoiceData?.data?.id,
              TYPE_ACTION_WORKFLOW.SUBMIT,
              null
            )
          );
          setIsSendSubmitEdit(false);
        } else {
          resetDataFunc();
        }
        break;
      case ADJUST_ISSUE_INVOICE_FAIL:
        if (
          adjustIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập hóa đơn điều chỉnh thất bại, tồn tại hóa đơn điều chỉnh chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập hóa đơn điều chỉnh thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetAdjustIssueInvoice());
        break;
      case DELETE_ISSUE_INVOICE_SUCCESS:
        addToast("Xóa hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        resetDataFunc();
        dispatch(resetDeleteIssueInvoice());
        break;
      case DELETE_ISSUE_INVOICE_FAIL:
        addToast(deleteInvoice.error, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteIssueInvoice());
        break;

      case CANCEL_ISSUE_INVOICE_SUCCESS:
        addToast("Gửi yêu cầu hủy hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmCancelModal();
        resetDataFunc();
        dispatch(resetCancelIssueInvoice());
        break;
      case CANCEL_ISSUE_INVOICE_FAIL:
        addToast("Gửi yêu cầu hủy hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelIssueInvoice());
        break;

      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalWorkflow) {
          toggleWorkflowModal();
        }
        resetDataFunc();
        if (workflowInvoice.typeWorkflow === TYPE_ACTION_WORKFLOW.APPROVE) {
          toggleTypeSignModal();
        }
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      }
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      //
      case CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS: {
        addToast("Tạo hóa đơn doanh nghiệp thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetCreateIssueInvoiceEnterprise());
        if (createInvoiceEnterpriseData?.data?.id) {
          history.push(`/invoice/${createInvoiceEnterpriseData?.data?.id}`);
        }
        break;
      }
      case CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL:
        addToast("Tạo hóa đơn doanh nghiệp thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateIssueInvoiceEnterprise());
        break;
      case UPLOAD_FILE_INVOICE_SUCCESS: {
        addToast("Upload biên bản đính kèm thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleUploadFileModal();
        dispatch(resetUploadFileInvoice());
        break;
      }
      case UPLOAD_FILE_INVOICE_FAIL:
        addToast("Upload biên bản đính kèm thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadFileInvoice());
        break;

      case EXPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      case GET_INVOICE_MIN_DATE_SUCCESS:
        if (!detailModal) {
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(rowRelease.ttchung_nlap * 1000),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyDenyRelease(
                `Đã có hóa đơn phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiện tại).`
              );
              toggleDenyReleaseModal();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyCheckRelease(
                `Đang có Hóa Đơn lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của hóa đơn hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành hóa đơn này hay không?`
              );
              toggleCheckReleaseModal();
            },
            () => {
              releaseInvoiceFunc(rowRelease);
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case GET_INVOICE_MIN_DATE_FAIL:
        if (!detailModal) {
          addToast("Lấy thông tin ngày lập hóa đơn lưu tạm xa nhất thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case DOWNLOAD_ZIP_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadZipInvoice());
        break;
      }
      case DOWNLOAD_ZIP_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadZipInvoice());
        break;
      default:
        break;
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisibleInvoice) {
      for (const item of initColumns) {
        if (
          issueInvoiceList.columnsVisibleInvoice[item.dataField] !== undefined
        ) {
          item.hidden = !issueInvoiceList.columnsVisibleInvoice[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    const targetColumn = columnsTable.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumnsTable(columnsTable);
    dispatch(setListIssueInvoiceColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    queryData();
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  const toggleDetailModal = (modeSet = "", isPage = false) => {
    if (isPage) {
      history.push("/invoice/all");
      return;
    }
    setDetailModal(!detailModal);
    switch (modeSet) {
      case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
      case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
      case issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL:
      case issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL:
        issueInvoiceList.params.page = 1;
        issueInvoiceList.params.sizePerPage = 10;
        issueInvoiceList.params.columnFilter = {
          ...issueInvoiceList.params.columnFilter,
          ...filterList,
        };
        queryData();
        break;
      default:
        break;
    }
  };
  const toastAddInvoice = () => {
    return addToast("Bạn chưa đăng ký sử dụng loại hóa đơn này", {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const showPdfById = (id, isConvert = false) => {
    setDataViewDocument({
      id,
      isConvert,
    });
    togglePdfViewModal();
  };

  const showPdfReturnGoodsById = id => {
    setDataViewDocument({
      id,
      isPolicy: true,
    });
    togglePdfViewModal();
  };

  const showSendMail = row => {
    setMailData({
      idInvoice: row.id,
      mailDefault: row.nmua_dctdtu,
    });
    toggleSendMailModal();
  };

  const checkBeforeRelease = row => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    setRowRelease(row);
    dispatch(
      getInvoiceMinDate(
        row?.ttchung_khmshdon,
        row?.ttchung_khhdon,
        row?.bu_code
      )
    );
  };

  const releaseInvoiceFunc = row => {
    // Nếu có liên kết hóa đơn lẻ và k phải hóa đơn thay thế thì mới tạo hóa đơn điều chỉnh 100%
    if (row.passersbyRoot && row.tthdlquan_tchdon === null) {
      setIsCreateAdjust(true);
      setIdAdjust(row.passersbyRoot.id);
    } else {
      setIsCreateAdjust(false);
    }
    setTransferData({
      id: row.id,
      mst: row.nban_mst,
      resource_id: getResourceIdXML(row.resource_list, "raw"),
      type: TYPE_TRANSFER.INVOICE,
      invoice_type: row.invoice_type,
    });
    toggleTypeSignModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      //   getListInvoiceSymbol(row.ttchung_khmshdon);
      if (row.adjust_mod) {
        setDataConfirmAction({
          typeAdjust: row.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }

      setPageViewByRow(row);
      setDataDetail({
        id: row.id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      switch (row.ttchung_khmshdon) {
        case "1":
          setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
          break;
        case "2":
          setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };
  const cloneEnvoice = id => {
    dispatch(getCloneEnvoice(id));
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-cloud-download font-size-18 text-primary" />,
      isDropdown: true,
      conditionVisible: {
        // ttchung_shdon: [null],
        auth_status: [AUTH_STATUS_APPROVE],
      },
      listDropdown: [
        {
          text: "Biên bản điều chỉnh hóa đơn",
          icon: <i className="fas fa-file-word font-size-18 text-primary" />,
          onClick: row => {
            dispatch(
              getInvoiceReportWord(
                row.id,
                TYPE_REPORT_WORD.ADJUST,
                getPathNameFile(row, "bienbandieuchinhhoadon")
              )
            );
          },
        },
        {
          text: "Biên bản điều chỉnh hủy hóa đơn",
          icon: <i className="fas fa-file-word font-size-18 text-danger" />,
          onClick: row => {
            dispatch(
              getInvoiceReportWord(
                row.id,
                TYPE_REPORT_WORD.CANCEL,
                getPathNameFile(row, "bienbandieuchinhhuy")
              )
            );
          },
        },
        {
          text: "Biên bản điều chỉnh thông tin khách hàng",
          icon: <i className="fas fa-file-word font-size-18 text-success" />,
          onClick: row => {
            dispatch(
              getInvoiceReportWord(
                row.id,
                TYPE_REPORT_WORD.INFO,
                getPathNameFile(row, "bienbandieuchinhthongtinkhachhang")
              )
            );
          },
        },
        {
          text: "Biên bản trả hàng",
          icon: <i className="fas fa-file-word font-size-18 text-warning" />,
          onClick: row => {
            dispatch(
              getInvoiceReportWord(
                row.id,
                TYPE_REPORT_WORD.GRA,
                getPathNameFile(row, "bienbantrahang")
              )
            );
          },
        },
      ],
      text: "Tải biên bản",
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      isDropdown: true,
      isShow: finalBuInfo?.can_convert === 1,
      classDropdown: "dropdown-menu-2",
      listDropdown: [
        {
          text: "Bản hiển thị",
          icon: <i className="bx bxs-file-pdf font-size-18 text-primary" />,
          onClick: row => {
            showPdfById(row.id);
          },
        },
        {
          text: "Bản chuyển đổi",
          icon: <i className="bx bxs-file-pdf font-size-18 text-success" />,
          auth_status: AUTH_STATUS_APPROVE,
          onClick: row => {
            showPdfById(row.id, true);
          },
        },
      ],
      text: "Xem file PDF",
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      isShow: finalBuInfo?.can_convert === 0 || finalBuInfo === null,
      onClick: row => {
        showPdfById(row.id);
      },
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
          switch (row.invoice_type) {
            // có mã
            case "1":
              mltdiep = "202";
              break;
            // không mã
            case "0":
              mltdiep = "204";
              break;
            default:
              break;
          }
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        if (resource_id) {
          dispatch(downloadXmlIssueInvoice(resource_id, row.ttchung_thdon));
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-primary" />,
      text: "Chính sách thu đổi",
      isShow: finalBuInfo?.is_exchange_policy === 1,
      conditionVisible: {
        // ttchung_shdon: [null],
        auth_status: [AUTH_STATUS_APPROVE],
      },
      onClick: row => {
        showPdfReturnGoodsById(row.id);
      },
    },
  ];

  const setPageViewByRow = row => {
    let pageView = "";
    if (row.invoice_type)
      switch (row.ttchung_khmshdon) {
        // Hóa đơn GTGT
        case "1":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        // Hóa đơn Bán hàng
        case "2":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    setPageView(pageView);
  };

  const actionReplaceOrAdjustInvoice = typeAdjust => {
    setDataConfirmAction({
      ...dataConfirmAction,
      typeAdjust,
    });
    setDataDetail({ id: dataConfirmAction.id });
    // getListInvoiceSymbol(dataConfirmAction.pattern);
    switch (dataConfirmAction.pattern) {
      case "1":
        setMode(issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL);
        break;
      case "2":
        setMode(issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL);
        break;
      default:
        break;
    }

    toggleDetailModal();
  };

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách hóa đơn",
      isLoading: exportInvoiceData.loading,
      loadingText: "Đang xuất danh sách hóa đơn",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...issueInvoiceList.params.columnFilter,
          sort: issueInvoiceList.params.sort
            ? issueInvoiceList.params.sort
            : "-checker_date",
          keywords: issueInvoiceList.params.keywords,
          "filter[is_problem]": 1,
        };
        dispatch(
          exportInvoice(
            objectExport,
            getFileNameExcel("Hóa đơn treo /lỗi truyền nhận"),
            "invoices"
          )
        );
      },
    },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-danger" />,
    //   text: `Download bản hiển thị của (${invoiceSelect.length}) hóa đơn`,
    //   isLoading: downloadZipInvoiceData.loading,
    //   loadingText: "Đang download bản hiển thị",
    //   onClick: data => {
    //     if (data.length === 0) {
    //       toastNoRowSelect(addToast, t);
    //     } else {
    //       dispatch(downloadZipInvoice(invoiceSelect, "pdf", "PDF_HOA_DON.zip"));
    //     }
    //   },
    // },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: `Download XML của (${invoiceSelect.length}) hóa đơn`,
    //   isLoading: downloadZipInvoiceData.loading,
    //   loadingText: "Đang download xml",
    //   onClick: data => {
    //     if (data.length === 0) {
    //       toastNoRowSelect(addToast, t);
    //     } else {
    //       dispatch(downloadZipInvoice(invoiceSelect, "xml", "XML_HOA_DON.zip"));
    //     }
    //   },
    // },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columnsTable
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "auth_status":
            for (const key in selectFilterAuthStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterAuthStatus[key];
            }
            break;
          case "approve_status":
            for (const key in selectFilterApproveStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterApproveStatus[key];
            }
            break;
          case "sent":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Chưa gửi mail";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "HÓA ĐƠN GTGT";
            objectExport[`columns[${formatData.dataField}][mapping][2]`] =
              "HÓA ĐƠN BH";
            break;
          case "ttchung_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttoan_tgtttbso":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    return objectExport;
  };

  const getLinkType = row => {
    let text = "";
    let className = "";
    let type = "";
    switch (row.link_type) {
      case LINK_TYPE.PARENT_REPLACE:
        className = "text-success";
        text = `HÓA ĐƠN GỐC ${
          listLinkTypeFilter.length === 0 ? " (BỊ THAY THẾ)" : ""
        }`;
        break;
      case LINK_TYPE.PARENT_ADJUST:
        className = "text-success";
        text = `HÓA ĐƠN GỐC ${
          listLinkTypeFilter.length === 0 ? " (BỊ ĐIỀU CHỈNH)" : ""
        }`;
        break;
      case LINK_TYPE.CHILD_REPLACE:
        className = "text-info";
        text = "HÓA ĐƠN THAY THẾ";
        break;
      case LINK_TYPE.CHILD_ADJUST:
        className = "text-primary";
        switch (row.adjust_mod) {
          case TYPE_ADJUST_INVOICE.INCREASE:
            type = "TĂNG";
            break;
          case TYPE_ADJUST_INVOICE.DECREASE:
            type = "GIẢM";
            break;
          case TYPE_ADJUST_INVOICE.CHANGE_INFO:
            type = "THÔNG TIN";
            break;
          default:
            break;
        }
        text = "HÓA ĐƠN ĐIỀU CHỈNH " + type;
        break;
      case LINK_TYPE.CHILD_REPLACE_TT32:
        className = "text-info";
        text = "HÓA ĐƠN THAY THẾ (CHO TT32)";
        break;
      case LINK_TYPE.CHILD_ADJUST_TT32:
        className = "text-primary";
        switch (row.adjust_mod) {
          case TYPE_ADJUST_INVOICE.INCREASE:
            type = "TĂNG";
            break;
          case TYPE_ADJUST_INVOICE.DECREASE:
            type = "GIẢM";
            break;
          case TYPE_ADJUST_INVOICE.CHANGE_INFO:
            type = "THÔNG TIN";
            break;
          default:
            break;
        }
        text = "HÓA ĐƠN ĐIỀU CHỈNH " + type + " (CHO TT32)";
        break;
      default:
        className = "text-success";
        text = "HÓA ĐƠN BÌNH THƯỜNG";
        break;
    }

    return (
      <React.Fragment>
        <div className={className} style={{ fontWeight: "bold" }}>
          {text}
        </div>
      </React.Fragment>
    );
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let process_status = row.process_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let progressDiv = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    if (status === AUTH_STATUS_APPROVE) {
      progressDiv = (
        <div className="d-flex gap-1 mt-2">
          <Badge
            className={`font-size-12 ${commonStatus?.PROGRESS_STATUS[process_status]?.badgeColor}`}
            pill
          >
            {commonStatus?.PROGRESS_STATUS[process_status]?.text}
          </Badge>
        </div>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            style={{ width: "110px", whiteSpace: "initial" }}
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>

          {infoError}
          {info}
        </div>
        {row.auto_sign === 1 && (
          <Badge
            style={{ width: "110px", whiteSpace: "initial", marginTop: "2px" }}
            className={`font-size-10 text-warning`}
            pill
          >
            Tự động phát hành
          </Badge>
        )}
        {/* {progressDiv} */}
      </React.Fragment>
    );
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row.approve_note?.workflowNote;
    let infoError = null;
    if (status === APPROVE_STATUS_R) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setNoteReject(note_deny);
            toggleRejectModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterAuthStatus = () => {
    const filter = {};
    for (const item of listStatusFilter) {
      if (selectFilterAuthStatus[item]) {
        filter[item] = selectFilterAuthStatus[item];
      }
    }
    return filter;
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Chờ duyệt hủy",
    [AUTH_STATUS_REJECT_CANCEL]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT_CANCEL]?.text, // "Từ chối hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",

    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getSelectFilterLinkType = () => {
    const filter = {};
    if (listLinkTypeFilter.length > 0) {
      for (const item of listLinkTypeFilter) {
        if (selectFilterLinkType[item]) {
          filter[item] = selectFilterLinkType[item];
        }
      }
      return filter;
    } else {
      return selectFilterLinkType;
    }
  };

  const selectFilterLinkType = {
    [LINK_TYPE.NORMAL]: "Hóa đơn bình thường",
    [LINK_TYPE.PARENT_REPLACE]: "Hóa đơn gốc (bị thay thế)",
    [LINK_TYPE.PARENT_ADJUST]: "Hóa đơn gốc (bị điều chỉnh)",
    [LINK_TYPE.CHILD_REPLACE]: "Hóa đơn thay thế",
    [LINK_TYPE.CHILD_ADJUST]: "Hóa đơn điều chỉnh",
    [LINK_TYPE.CHILD_REPLACE_TT32]: "Hóa đơn thay thế (cho TT32)",
    [LINK_TYPE.CHILD_ADJUST_TT32]: "Hóa đơn điều chỉnh (cho TT32)",
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    if (isRoleAccountant) {
      listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getClientType = row => {
    let client_type = row.client_type;
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.CLIENT_TYPE[client_type]?.badgeColor}`}
            pill
          >
            {commonStatus?.CLIENT_TYPE[client_type]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterClientType = () => {
    return selectFilterClientType;
  };

  const selectFilterClientType = {
    [CLIENT_TYPE_CONST.SALE]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE]?.text,
    [CLIENT_TYPE_CONST.SALE_ADJ]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE_ADJ]?.text,
    [CLIENT_TYPE_CONST.IBT_GTGT]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_GTGT]?.text,
    [CLIENT_TYPE_CONST.GRA]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA]?.text,
    [CLIENT_TYPE_CONST.GRA_ADJ]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA_ADJ]?.text,
    // [CLIENT_TYPE_CONST.IBT]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT]?.text,
    // [CLIENT_TYPE_CONST.IBT_CSM]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_CSM]?.text,
  };

  const selectFilterDone = {
    ["1"]: "Đã xử lý",
    ["0"]: "Chưa xử lý",
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev" || isEnterprise,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "campaign_id",
      text: "Hóa đơn theo lô",
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return (
            <div style={{ fontWeight: "bold" }}>
              Id: <span className="text-info">{cell}</span>
            </div>
          );
        }
        return "";
      },
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
        style: { maxWidth: "120px" },
      }),
      //   hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU || isEnterprise,
    },
    {
      dataField: "client_ref_uuid",
      text: "Số tham chiếu",
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
        style: { width: "120px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "nmua_mkhang",
      text: "Mã khách hàng",
      hidden: isEnterprise,
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "link_type",
      text:
        listLinkTypeFilter.length > 0
          ? listLinkTypeFilter?.includes(LINK_TYPE.PARENT_REPLACE)
            ? "Hóa đơn gốc/ Thay thế"
            : "Hóa đơn gốc/ Điều chỉnh"
          : "Hóa đơn gốc / Thay thế/ Điều chỉnh",
      hidden: listLinkTypeFilter.length === 0,
      formatter: (cellContent, row) => getLinkType(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterLinkType(),
        // style: { maxWidth: "140px" },
      }),
    },
    {
      dataField: "nmua_ten",
      text: "Tên khách hàng",
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ width: "150px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "nmua_mst",
      text: "MST KH",
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
      }),
      hidden: isEnterprise,
    },
    {
      dataField: "ttoan_tgtttbso",
      text: "Tổng tiền",
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cell, row) => {
        return numberWithCommas(cell);
      },
    },

    // {
    //   dataField: "ttchung_thdon",
    //   text: t("table.invoice_name"),
    //   sort: true,
    //   filter: textFilter({
    //     placeholder: t("placeholder.enter"),
    //   }),
    // },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterAuthStatus(),
        style: { width: "100px" },
      }),
    },
    {
      dataField: "status_done",
      text: "Tình trạng xử lý",
      hidden: false,
      formatter: (cellContent, row) => {
        let text = "Chưa xử lý";
        let className = "badge-soft-warning";
        if (
          row.auth_status === AUTH_STATUS_APPROVE ||
          row.auth_status === AUTH_STATUS_CANCEL
        ) {
          text = "Đã xử lý";
          className = "badge-soft-success";
        }
        return (
          <div className="d-flex gap-1">
            <Badge
              style={{ width: "110px", whiteSpace: "initial" }}
              className={`font-size-12 ${className}`}
              pill
            >
              {text}
            </Badge>
          </div>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterDone,
        style: { width: "100px" },
      }),
    },
    {
      dataField: "approve_status",
      text: "TT duyệt",
      hidden: finalBuInfo?.need_approve === 0,
      formatter: (cellContent, row) => getApproveStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterApproveStatus(),
        style: { width: "60px" },
      }),
    },

    // {
    //   dataField: "ttchung_khmshdon",
    //   text: t("table.invoice_model_number_symbol"),
    //   hidden: true,
    // },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) =>
        row.ttchung_khmshdon + row.ttchung_khhdon,
    },
    {
      dataField: "ttchung_shdon",
      text: "Số HĐ",
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) =>
        tableFormateDate(row.ttchung_nlap, false, true),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "ttchung_khmshdon",
      text: "Loại Hóa đơn",
      hidden: false,
      formatter: (cellContent, row) => {
        let content = "";
        let info = null;
        let passersbyRoot = row.passersbyRoot;
        let passersbyChild = row.passersbyChild;
        if (passersbyRoot) {
          info = (
            <div
              id={"message" + row.id}
              className="font-size-14 text-primary d-flex gap-1 align-items-center"
              style={{ cursor: "pointer" }}
            >
              Cho doanh nghiệp
              <i
                //   style={{ cursor: "pointer" }}
                className="bx bx-info-circle text-primary"
              ></i>
              <UncontrolledTooltip
                placement="left"
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  background: "white",
                  color: "black",
                  border: "1px solid blue",
                  minWidth: "300px",
                }}
                target={"message" + row.id}
              >
                <span style={{ fontWeight: "bold" }} className="text-primary">
                  Được tạo từ hóa đơn khách hàng lẻ.
                </span>{" "}
                <br />
                Số hóa đơn: {passersbyRoot.ttchung_shdon} <br />
                Ký hiệu: {passersbyRoot.ttchung_khmshdon}
                {passersbyRoot.ttchung_khhdon}
                <br />
                Id: {passersbyRoot.id}
              </UncontrolledTooltip>
            </div>
          );
        }
        if (passersbyChild) {
          info = (
            <div
              style={{ cursor: "pointer" }}
              id={"message" + row.id}
              className="font-size-14 text-success d-flex gap-1 align-items-center"
            >
              Cho khách hàng lẻ
              <i
                //   style={{ cursor: "pointer" }}
                className="bx bx-info-circle text-success"
              ></i>
              <UncontrolledTooltip
                placement="left"
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  background: "white",
                  color: "black",
                  border: "1px solid green",
                  minWidth: "300px",
                }}
                target={"message" + row.id}
              >
                <span style={{ fontWeight: "bold" }} className="text-success">
                  Đã tạo hóa đơn doanh nghiệp
                </span>{" "}
                <br />
                Số hóa đơn:{" "}
                {passersbyChild.ttchung_shdon
                  ? passersbyChild.ttchung_shdon
                  : "Chưa cấp số"}{" "}
                <br />
                Ký hiệu: {passersbyChild.ttchung_khmshdon}
                {passersbyChild.ttchung_khhdon}
                <br />
                Id: {passersbyChild.id}
              </UncontrolledTooltip>
            </div>
          );
        }
        switch (cellContent) {
          case "1":
            content = "HĐ GTGT";
            break;
          case "2":
            content = "HĐ BH";
            break;
          default:
            break;
        }
        return (
          <React.Fragment>
            <div style={{ width: "150px", whiteSpace: "initial" }}>
              <div>{content}</div> {info}
            </div>
          </React.Fragment>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          1: "HĐ GTGT",
          2: "HĐ BH",
        },
      }),
    },
    {
      dataField: "sent",
      text: "Trạng thái gửi mail",
      hidden: isEnterprise,
      sort: true,
      formatter: (cellContent, row) => {
        if (cellContent === 0) {
          return (
            <div className="d-flex gap-1 mt-2">
              <Badge className={`font-size-12 badge-soft-warning`} pill>
                Chưa gửi mail
              </Badge>
            </div>
          );
        } else if (cellContent === 1) {
          return (
            <div className="d-flex gap-1 mt-2">
              <Badge className={`font-size-12 badge-soft-success`} pill>
                Đã gửi mail
              </Badge>
            </div>
          );
        }
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          0: "Chưa gửi mail",
          1: "Đã gửi mail",
        },
      }),
    },
    {
      dataField: "maker.display_name",
      text: t("table.maker_id"),
      hidden: isEnterprise,
      sort: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      hidden: isEnterprise,
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      //   filter: customFilter({
      //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      //   }),
      //   filterRenderer: (onFilter, column) => (
      //     <CustomDateFilter
      //       onFilter={onFilter}
      //       column={column}
      //       paramFilter={issueInvoiceList.params.columnFilter}
      //     />
      //   ),
    },
    {
      dataField: "client_type",
      text: "Nguồn",
      hidden: !isEnterprise,
      formatter: (cellContent, row) => getClientType(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterClientType(),
        style: { width: "138px" },
      }),
    },
  ];

  const resetDataFunc = () => {
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Breadcrumbs
          title={t(titleManger)}
          breadcrumbItem={t(title) + ` (${issueInvoiceList.totalCount})`}
        />
        <Row>
          {/* Modal START*/}
          <Col className="col-12">
            {/* Hình thức ký modal */}
            <TypeSignDigitalModal
              t={t}
              isOpen={modalTypeSign}
              transferData={transferData}
              toggle={toggleTypeSignModal}
              toggleUSBSignModal={toggleUSBSignModal}
              toggleHSMSignModal={toggleHSMSignModal}
            />
            {/* Ký USB Modal */}
            <VerifyPinUSBModal
              t={t}
              isOpen={modalUSBSign}
              isCreateAdjust={isEnterprise && isCreateAdjust}
              downloadXmlFunc={downloadXmlIssueInvoice}
              transferData={transferData}
              resetDataFunc={resetDataFunc}
              toggle={toggleUSBSignModal}
            />
            {/* Ký HSM Modal */}
            <SignHSMModal
              t={t}
              isCreateAdjust={isEnterprise && isCreateAdjust}
              idAdjust={idAdjust}
              isOpen={modalHSMSign}
              transferData={transferData}
              resetDataFunc={resetDataFunc}
              invoice_type={transferData?.invoice_type}
              releaseFunc={releaseIssueInvoice}
              resetReleaseFunc={resetReleaseIssueInvoice}
              toggle={toggleHSMSignModal}
            />
            {/* CheckRelease modal */}
            <ConfirmModal
              isOpen={modalCheckRelease}
              titleHeader={"Xác nhận Phát hành hóa đơn"}
              titleBody={titleBodyCheckRelease}
              onConfirm={note => {
                toggleCheckReleaseModal();
                if (!detailModal) {
                  // phát hành ngoài list
                  releaseInvoiceFunc(rowRelease);
                } else {
                  // phát hành trong detail
                  childRef?.current?.releaseFromDetail();
                }
              }}
              textBtnConfirm={"Xác nhận"}
              textBtnCancel={"Đóng"}
              toggle={toggleCheckReleaseModal}
            />
            {/* CheckRelease modal */}
            <ConfirmModal
              isOpen={modalDenyRelease}
              titleHeader={"Từ chối phát hành hóa đơn"}
              titleBody={titleBodyDenyRelease}
              onConfirm={note => {
                toggleDenyReleaseModal();
              }}
              textBtnConfirm={"Xác nhận"}
              textBtnCancel={"Đóng"}
              toggle={toggleDenyReleaseModal}
            />
            <CompareInvoiceModal
              showPdfById={showPdfById}
              setDataCompare={setDataCompare}
              dataCompare={dataCompare}
              isOpen={modalCompareInvoice}
              toggle={toggleCompareInvoiceModal}
            />
            {/* ErrorReleaseModal */}
            <ErrorReleaseModal
              isOpen={modalErrorRelease}
              toggle={toggleErrorReleaseModal}
              id={idRelease}
              path={"invoices"}
            />
            {/* PDFViewModal */}
            <PDFViewModal
              isOpen={modalPdfView}
              dataViewDocument={dataViewDocument}
              toggle={togglePdfViewModal}
            ></PDFViewModal>
            {/* HistoryTransferModal */}
            <HistoryTransferModal
              isOpen={modalHistoryTransfer}
              toggle={toggleHistoryTransferModal}
              id={idHistory}
              path={"invoices"}
            />
            {/* Detail Modal */}
            <DetailInvoice
              ref={childRef}
              btnShowFooter={btnShowFooter}
              dataDetail={dataDetail}
              isEnterprise={isEnterprise}
              dataConfirmAction={dataConfirmAction}
              isOpenModal={detailModal}
              toggleModal={toggleDetailModal}
              showPdfById={showPdfById}
              mode={mode}
              pageView={pageView}
              invoiceSymbolList={invoiceSymbolList.items}
              isRoleStore={isRoleStore}
              isRoleAccountant={isRoleAccountant}
              setTitleBodyDenyRelease={setTitleBodyDenyRelease}
              toggleDenyReleaseModal={toggleDenyReleaseModal}
              setTitleBodyCheckRelease={setTitleBodyCheckRelease}
              toggleCheckReleaseModal={toggleCheckReleaseModal}
            />
          </Col>
          {/* Modal E N D*/}
          <Col className="col-12">
            <Card>
              <CardBody>
                <RemoteDataTable
                  // selectRow={selectRowCheckbox}
                  // isShowPagination={false}
                  // onRowsSelect={onRowsSelect}
                  // expandRow={expandRowTable}
                  isShowSTT={isEnterprise ? false : true}
                  keyField="id"
                  data={issueInvoiceList.items}
                  columns={columnsTable}
                  page={issueInvoiceList.params.page}
                  sizePerPage={issueInvoiceList.params.sizePerPage}
                  totalSize={issueInvoiceList.totalCount}
                  onTableChange={handleTableChange}
                  onSearchAllHandle={onSearchAllHandle}
                  optionShowColumnHandel={optionShowColumnHandler}
                  rowEvents={rowEventsHandler}
                  listMultipleRowAction={listMultipleRowAction}
                  listRowAction={listRowAction}
                  loading={loadingList}
                >
                  {children}
                  {/* <Button
                      type="button"
                      color="primary"
                      className="me-2 btn-label"
                      onClick={() => {
                        if (toastWarningIsAllStore(addToast)) {
                          return;
                        }
                        history.push("/invoice/create");
                      }}
                    >
                      <i className="bx bx-plus label-icon" />
                      {t("table.btn_create")}
                    </Button> */}
                </RemoteDataTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

ListInvoiceError.propTypes = {
  filterList: PropTypes.object.isRequired,
  title: PropTypes.string,
  titleManger: PropTypes.string,
  listStatusFilter: PropTypes.array,
  listLinkTypeFilter: PropTypes.array,
  isErrorTCT: PropTypes.bool,
  children: PropTypes.any,
  isClickSwitch: PropTypes.bool,
};

ListInvoiceError.defaultProps = {
  isErrorTCT: false,
  filterList: {},
  listStatusFilter: [],
  listLinkTypeFilter: [],
};

export default ListInvoiceError;
